module.exports = __webpack_public_path__ + "img/fingerprint-04.77d1045f.svg";